export const moveHelpTextToDragAndDrop = () => {
    const helpText = document.querySelector('.upload-files-frame .help-text')
    const dropZone = document.querySelector('.upload-files-frame .drag-and-drop .label')

    if (helpText && dropZone) {
        dropZone.appendChild(helpText)
    }
}
